import { Component, OnDestroy } from '@angular/core';
import { QbuiltNavbarComponent } from '../shared/qbuilt-navbar/qbuilt-navbar.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { QBuiltInspectorConstants } from '../models/constants/qbuilt-inspector.constants';
import { InspectionContentComponent } from "../shared/inspection-content/inspection-content.component";
import { SerialTabModel } from '../shared/models/serial-tab.models';
import { QBuiltInspectorDialogService } from '../shared/services/inspector-dialog.service';
import { QBuiltSharedInspService } from '../shared/services/qbuilt-shared.service';
import { MatIconModule } from '@angular/material/icon';
import { QBuiltInspectorService } from '../services/qbuilit-inspector.service';
import { InspectionInitiationModel } from '../models/qbuilt-inspector.models';
import { ChangeDetectorRef } from '@angular/core';
import { Subject, take, takeUntil, filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector: 'active-inspection',
    imports: [
        QbuiltNavbarComponent,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatProgressBarModule,
        InspectionContentComponent,
        MatIconModule,
        CommonModule,
        MatTooltipModule
    ],
    templateUrl: './active-inspection.component.html',
    styleUrl: './active-inspection.component.scss'
})
export class ActiveInspectionComponent implements OnDestroy {
  //session storage keys
  defectItemsKey: string = this.qBuiltInspectorConstants.defectItemsKey;
  cqmsSessionKey: string = this.qBuiltInspectorConstants.cqmsItemsKey;
  landingPageKey: string = this.qBuiltInspectorConstants.landingPageItemsKey;

  tabList: SerialTabModel[] = [];
  zoneSelection: string = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneName || JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').currentTabList[0]?.zoneSelection || '';
  selected: number;
  newTabText: string = this.qBuiltInspectorConstants.newTabText;
  saveProgressText: string = this.qBuiltInspectorConstants.saveProgressText;

  isLoading: boolean = true;
  singleWide: boolean = true;
  sectionList: any[] = [];

  facilityNumber: string = sessionStorage.getItem('facilityNumber') || localStorage.getItem('facilityNumber') || '';
  defectList: any[] = [];
  defectFormList: any[] = [];
  stationIdList: any[] = [];
  homeSections: string[] = [];

  tabLoading: boolean = true;
  newInspectionData: any[] = [];
  activeSerial: string = localStorage.getItem('activeSerial') || '';
  activeInspections: boolean = JSON.parse(sessionStorage.getItem(this.landingPageKey) || '{}').activeInspections || false;  
  private isManualAdd = false;

  saveProgressLoad: boolean = false;
  tabListHasBeenSet: boolean = false;

  sectionsSaved: number = 0;
  totalSectionsToSave: number = 0;

  defectLocationChecks: any[] = [];

  locationIdTooltip: string = this.qBuiltInspectorConstants.locationIdTooltip;
  submitSignOffTooltip: string = this.qBuiltInspectorConstants.submitSignOffTooltip;

  private destroy$ = new Subject<void>();
  currentZoneId: string = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId || '';

  cqmsSessionItems: any;
  cqmsSessionDefectItems = {
    defectList: [] as any[],
    defectFormList: [] as any[]
  };

  private _defectLocationOk: boolean = true;
  private _saveProgressCache: boolean | undefined = undefined;

  constructor(
    private qBuiltInspectorConstants: QBuiltInspectorConstants,
    private qbuiltDialog: QBuiltInspectorDialogService,
    private qbuiltInspSrv: QBuiltInspectorService,
    private qbuiltSharedInspService: QBuiltSharedInspService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.isLoading = true;
    const session = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}');
    // Refresh zone context from sessionStorage on every init so stale Zone 1 values
    // don't bleed into a new Zone 2 session when the component instance is reused.
    this.currentZoneId = session.zoneId || '';
    this.zoneSelection = session.zoneName || session.currentTabList?.[0]?.zoneSelection || '';
    this.tabList = session.currentTabList || [];
    sessionStorage.setItem(this.defectItemsKey, JSON.stringify(this.cqmsSessionDefectItems));
    //Scenario 1: User selected a new serial# and just landed on the page without a tablist yet
    if(this.activeSerial && this.tabList.length === 0 && this.activeInspections === false && !this.isManualAdd) {
      this.getNewSerialData(this.activeSerial);
      //populate the tablist after gathering the new serial data
      if(this.tabList.length > 0) {
          this.tabList.forEach((tab) => {
          if(tab.serialNumber === this.activeSerial) {
            this.selected = tab.tabIndex;
            this.singleWide = tab.sectionCount > 1 ? false : true;
            this.cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
            this.cqmsSessionItems = { ...this.cqmsSessionItems, sectionList: tab.sectionList, activeSerial: tab.serialNumber };
            sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));          }
        });
      }
    }//Scenario 2: User navigates from active inspections button without an active serial 
    else if(!this.activeSerial && this.tabList.length > 0) {
      this.tabList.forEach((tab) => {
        if(tab.tabIndex === this.selected) {
          this.selected = tab.tabIndex;
          this.singleWide = tab.sectionCount > 1 ? false : true;
          this.sectionList = tab.sectionList;
     this.cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
          this.cqmsSessionItems = { ...this.cqmsSessionItems, sectionList: tab.sectionList, activeSerial: tab.serialNumber };
          sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));        }
      });
    }//Scenario 3: User has an active Serial# AND active inspections
    else if(this.activeSerial && this.tabList.length > 0 && this.activeInspections === true && !this.isManualAdd) {
      // Only fetch data for serials not already loaded — prevents stale BehaviorSubject
      // data from a previous zone being replayed onto an already-present tab.
      const alreadyLoaded = this.tabList.some(tab => tab.serialNumber === this.activeSerial);
      if (!alreadyLoaded) {
        this.getNewSerialData(this.activeSerial);
      }
    }

    this.sectionList = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').sectionList || [];
    this.selected = parseInt(JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').activeTabIndex || '0');
    this.getStationIds(this.sectionList);
    this.tabSelection(this.selected);
  }

ngDoCheck(): void {
  this._saveProgressCache = undefined;
}

get saveProgressInvalid(): boolean {
  if (this._saveProgressCache === undefined) {
    this._defectLocationOk = this.defectLocationCheck();
    this._saveProgressCache = !this._defectLocationOk || !this.submitSignoffCheck();
  }
  return this._saveProgressCache;
}

getToolTipText(): string {
  if (!this._defectLocationOk) {
    return this.locationIdTooltip;
  }

  if (!this.submitSignoffCheck()) {
    return this.submitSignOffTooltip;
  }
  return '';
}

  //gather data for first time serial#
getNewSerialData(activeSerial: string) {
  (this.qbuiltInspSrv.inspectionInitiationResponse$)
    .pipe(filter(response => !!response), take(1), takeUntil(this.destroy$))
    .subscribe(response => {
      // Prevent duplicate tab creation
      const alreadyExists = this.tabList.some(tab => tab.serialNumber === activeSerial);
      if (alreadyExists) {
        console.warn(`Tab for serial ${activeSerial} already exists — skipping duplicate`);
        return;
      }

      let updatedData;
      try {
        updatedData = typeof response.UpdatedData === 'string' && response.UpdatedData.trim().length > 0
          ? JSON.parse(response.UpdatedData)
          : response.UpdatedData;
      } catch (err) {
        console.error('Failed to parse UpdatedData:', err);
        return;
      }

      const newTab: SerialTabModel = {
        serialNumber: activeSerial,
        statusId: updatedData.HBGInspectionStatusId,
        tabIndex: this.tabList.length,
        sectionList: updatedData.Sections,
        sectionCount: updatedData.Sections.length,
        zoneSelection: this.zoneSelection
      };
    
      // Update tab list and persist
      this.tabList = [...this.tabList, newTab];
      this.qbuiltSharedInspService.setCurrentTabList(this.tabList);
      this.saveTabListIfValid(this.tabList);
    
     //set session storage items for current active tab
     let cqmsSessionItems = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}');
      cqmsSessionItems = { ...cqmsSessionItems, 
        currentTabList: this.tabList, 
        activeSerial: newTab.serialNumber, 
        activeTabIndex: newTab.tabIndex, 
        sectionList: newTab.sectionList 
      };
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));

      // Update component state
      this.sectionList = newTab.sectionList;
      this.singleWide = newTab.sectionCount > 1 ? false : true;
      this.getStationIds(this.sectionList);

      // Defer tab activation to next change detection cycle
      setTimeout(() => {
        this.selected = newTab.tabIndex;
        this.tabSelection(newTab.tabIndex);
        this.cdr.detectChanges(); // ensure UI reflects selected tab
      }, 0);
    });
}

saveTabListIfValid(tabList: SerialTabModel[]) {
  if (!Array.isArray(tabList) || tabList.length === 0) {
    console.warn('Skipping save: tabList empty or invalid', tabList);
    return;
  }

  this.qbuiltInspSrv.saveInspectionProgressToDynamo(this.facilityNumber, this.currentZoneId, tabList);
}

  getStationIds(sectionList: any[]) {
    const uniqueIds = new Set<number>();
    this.stationIdList = [];
    sectionList.forEach(section => {
      section.Stations.forEach((station: any) => {
        uniqueIds.add(station.Id);
      });
    });

    this.stationIdList = Array.from(uniqueIds);
    this.cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    this.cqmsSessionItems.stationIdList = this.stationIdList;
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
    this.isLoading = false;
  }

  //tracks which tab is clicked on
  tabSelection(index: number) {
    const raw = sessionStorage.getItem(this.cqmsSessionKey);
    const sessionData = raw ? JSON.parse(raw) : {};
    this.tabList = sessionData.currentTabList || [];
    this.selected = index;

    //reset active serial
    this.tabList.forEach((tab) => {
      if(tab.tabIndex === index) {
        this.singleWide = tab.sectionCount > 1 ? false : true;
        this.sectionList = tab.sectionList;
        this.cqmsSessionItems = { ...sessionData, activeSerial: tab.serialNumber, sectionList: tab.sectionList, activeTabIndex: index };
        sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
      }
    });
    this.tabLoading = false;
  }
  //add new serial tab across the top
addNewSerial(selectedIndex: number) {
  this.tabLoading = true;
  const dialogRef = this.qbuiltDialog.openInspectorDialog(1);

  dialogRef.afterClosed().pipe(take(1)).subscribe((result) => {
    if (!result || !result.serialNumber) {
      this.tabLoading = false;
      return;
    }

    const alreadyExists = this.tabList.some(tab => tab.serialNumber === result.serialNumber);
    if (alreadyExists) {
      console.warn(`Tab for serial ${result.serialNumber} already exists — skipping duplicate`);
      this.tabLoading = false;
      return;
    }
    const finalObj = this.setupActiveInspection(result);
    this.isManualAdd = true;

    this.qbuiltInspSrv.saveNewInspection(finalObj).pipe(take(1)).subscribe(data => {
      if (!data || !data.UpdatedData) {
        console.warn('No UpdatedData received — skipping tab creation');
        this.tabLoading = false;
        return;
      }

      let updatedData;
      try {
        updatedData = typeof data.UpdatedData === 'string' && data.UpdatedData.trim().length > 0
          ? JSON.parse(data.UpdatedData)
          : data.UpdatedData;
      } catch (err) {
        console.error('Failed to parse UpdatedData:', err);
        this.tabLoading = false;
        return;
      }

      this.sectionList = updatedData.Sections;

      const newTab: SerialTabModel = {
        serialNumber: result.serialNumber,
        statusId: updatedData.HBGInspectionStatusId, 
        tabIndex: this.tabList.length,
        sectionCount: result.sectionCount,
        zoneSelection: this.zoneSelection,
        sectionList: this.sectionList
      };

      // Use in-memory tabList — do NOT reload from sessionStorage here.
      // Re-reading sessionStorage risks loading a stale Zone 1 currentTabList when
      // a Zone 2 session is starting, which would append the new tab to the wrong zone's list.
      this.tabList = [...this.tabList, newTab];
      this.qbuiltSharedInspService.setCurrentTabList(this.tabList);
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify({ ...JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}'), currentTabList: this.tabList }));
      this.saveTabListIfValid(this.tabList);
        
      setTimeout(() => {
        this.tabSelection(newTab.tabIndex);
      }, 0);

      this.isManualAdd = false;
      this.tabLoading = false;
    });
  });
}


  /** writes data to db for new inspection */
  setupActiveInspection(result: any) {
    let zoneId = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId || '';
    this.getSectionCount(result.sectionCount);    
    //logic to save to db here
    let inspInitiationObj: InspectionInitiationModel = {
      SerialNumber: result.serialNumber,
      PlantNumber: this.facilityNumber,
      HomeSections: this.homeSections,
      ZoneId: parseInt(zoneId)
    };

    return inspInitiationObj;
  }

  //Converts home sections from # into list string A,B,C etc
  getSectionCount(sectionCount: number) {
    let sectList = Array.from({ length: sectionCount }, (_, i) => i + 1);
    sectList.forEach((section) => {
      if(this.homeSections.includes(String.fromCharCode(64 + section)) === false) {
        this.homeSections.push(String.fromCharCode(64 + section));
      }
    });
  }

  //Insures that all child content is loaded -- fixes issue with open defects
  LoadComplete(event: any) {
    if(event === true) {
      this.tabLoading = false;
    }
  }

  //checks if any defects are missing locationids to prevent save progress with missing locationids
  defectLocationCheck(): boolean {
  let data = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').currentTabList || [];
    this.defectLocationChecks = [];
    data.forEach((serialItem: any) => {
      const serialNumber = serialItem.serialNumber ?? serialItem.SerialNumber ?? ''; // depending on shape
      serialItem.sectionList.forEach((section: any) => {
        section.Stations.forEach((station: any) => {
          if (Array.isArray(station.DefectedTasks) && station.DefectedTasks.length > 0) {
            station.DefectedTasks.forEach((defectTask: any) => {
              // push pair for validation; avoid duplicates by TaskExecutionId
              const alreadyTracked = this.defectLocationChecks.some(
                (d: any) =>
                  d.taskExecutionId === defectTask.TaskExecutionId &&
                  d.serialNumber === defectTask.SerialNumber
              );
              if (!alreadyTracked) {
                this.defectLocationChecks.push({
                  serialNumber: defectTask.SerialNumber ?? serialNumber,
                  locationId: defectTask.LocationId ?? 0,
                  taskExecutionId: defectTask.TaskExecutionId,
                });
              }
            });
          }
        });
      });
    });


    // disable save when any defect has missing location
    const hasMissingLocation = this.defectLocationChecks.some((d: any) => d.locationId === 0);
    return !hasMissingLocation;
  } 

  //checks if submit and signoff is ready to prevent user from falling into save progress lock bug
  //TODO -- make sure this works with more than one station
  submitSignoffCheck(): boolean {
    let saveProgressDisabled = sessionStorage.getItem('saveProgressDisabled') === 'false' ? false : true;
    return saveProgressDisabled;
  }

  onTabComplete(event: any) {
    if(event.serialNumber) {
      //remove the serial from the tabList and and defects from defect list
      this.defectList = this.defectList.filter(defect => defect.SerialNumber !== event.serialNumber);
          this.cqmsSessionDefectItems = JSON.parse(sessionStorage.getItem(this.defectItemsKey) || '{}');
      this.cqmsSessionDefectItems.defectList = this.defectList;
      sessionStorage.setItem(this.defectItemsKey, JSON.stringify(this.cqmsSessionDefectItems));

      //sessionStorage.setItem('defectList', JSON.stringify(this.defectList));
      this.qbuiltSharedInspService.setCurrentDefectList(this.defectList);
      this.tabList = this.tabList.filter(tab => tab.serialNumber !== event.serialNumber);
      //reset tab indexes
      this.tabList.forEach((tab, index) => {
        tab.tabIndex = index;
      });
      
      this.qbuiltSharedInspService.setCurrentTabList(this.tabList);
      this.qbuiltInspSrv.saveInspectionProgressToDynamo(this.facilityNumber, this.currentZoneId, this.tabList);
      localStorage.setItem('activeSerial', this.tabList[0]?.serialNumber || '');
      this.selected = 0;  
      sessionStorage.setItem('saveProgressDisabled', 'false');

      this.cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
      this.cqmsSessionItems = { ...this.cqmsSessionItems, 
        currentTabList: this.tabList,
        activeSerial: this.tabList[0]?.serialNumber || '',
        sectionList: this.tabList[0]?.sectionList, 
        activeTabIndex: 0
      };
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(this.cqmsSessionItems));
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    // Clear the shared BehaviorSubject so stale zone data is never replayed
    // when a different zone's active-inspection component subscribes next.
    this.qbuiltInspSrv.clearInspectionInitiationResponse();
    this.destroy$.next();
    this.destroy$.complete();
  }

  //method called on save progress button click -- calls service method to save to dynamo
  saveInspectionProgress() {
    let tabListToSave = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').currentTabList || this.tabList;
    console.log('tablist to save on save progress click:', tabListToSave);
    this.qbuiltInspSrv.saveInspectionProgressToDynamo(this.facilityNumber, this.currentZoneId, tabListToSave);
    
  }

}
